import React from "react";
import {
  CircularProgress,
  Button,
  Step,
  Stepper,
  StepLabel,
  Typography
} from "@material-ui/core";
import PropTypes from "prop-types";
import FilePickerStep from "./FilePickerStep";
import ValidateStep from "./ValidateStep";
import SaveToDBStep from "./SaveToDBStep";
import { plural } from "./UploadCommon";

const UploadStepper = props => {
  const getStepContent = stepIndex => {
    switch (stepIndex) {
      case 0:
        return <FilePickerStep {...props} />;
      case 1:
        return <ValidateStep {...props} />;
      case 2:
        return <SaveToDBStep {...props} />;
      default:
        return "You're a long way from home sonny jim!";
    }
  };
  const handleNext = () => {
    const { stepIndex, allFilesUploaded } = props;
    if (stepIndex < 2) props.actions.setStepIndex(stepIndex + 1);

    if (stepIndex === 0) {
      props.validateFiles();
    }
    if (stepIndex === 2) {
      if (allFilesUploaded) props.actions.resetFiles();
      else props.actions.saveAllFilesToDB();
    }
  };
  const handlePrev = () => {
    if (props.stepIndex > 0) {
      props.actions.setStepIndex(props.stepIndex - 1);
    }
  };
  const contentStyle = { margin: "0 16px" };

  let nextLabel;
  const progressCircle = (
    <CircularProgress style={{ marginTop: "5px" }} size={25} />
  );
  if (props.stepIndex === 1 && props.isValidating) nextLabel = progressCircle;
  else if (props.stepIndex === 2) {
    if (props.someFilesAreUploading) nextLabel = progressCircle;
    else if (props.allFilesUploaded) nextLabel = "Done";
    else
      nextLabel = `Save ${plural(
        props.filesNotYetUploaded.length,
        "file"
      )} to ${props.selectedOrganization} database`;
  } else nextLabel = "Next";

  return (
    <div style={{ width: "100%", margin: "auto" }}>
      <Stepper activeStep={props.stepIndex}>
        <Step>
          <StepLabel>Choose files to upload</StepLabel>
        </Step>
        <Step>
          <StepLabel>Check to see if there are any errors</StepLabel>
        </Step>
        <Step>
          <StepLabel>
            Upload the file
            {props.files.length === 1 ? "" : "s"} to the database
          </StepLabel>
        </Step>
      </Stepper>
      <div style={contentStyle}>
        <div>
          <div>{getStepContent(props.stepIndex)}</div>
          <div style={{ marginTop: 12 }}>
            <Typography variant="caption" style={{ color: "red" }}>
              {props.stepIndex === 0 &&
              props.files.length &&
              !props.selectedOrganization
                ? "Select organization to continue"
                : ""}
            </Typography>
            <Button
              variant="text"
              disabled={props.stepIndex === 0}
              onClick={() => handlePrev()}
              style={{ marginRight: 12 }}
            >
              Back
            </Button>
            <Button
              disabled={
                (props.stepIndex === 0 &&
                  (!props.files.length || !props.selectedOrganization)) ||
                (props.stepIndex === 1 &&
                  (!props.noFilesHaveValidationErrors ||
                    !props.files.length ||
                    !props.allFilesHaveValidated))
              }
              color="secondary"
              onClick={() => handleNext()}
            >
              {nextLabel}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};
UploadStepper.propTypes = {
  files: PropTypes.arrayOf(PropTypes.object).isRequired,
  selectedOrganization: PropTypes.string,
  filesNotYetUploaded: PropTypes.arrayOf(PropTypes.object).isRequired,
  isValidating: PropTypes.bool.isRequired,
  allFilesUploaded: PropTypes.bool.isRequired,
  someFilesAreUploading: PropTypes.bool.isRequired,
  allFilesHaveValidated: PropTypes.bool.isRequired,
  validateFiles: PropTypes.func.isRequired,
  stepIndex: PropTypes.number.isRequired,
  noFilesHaveValidationErrors: PropTypes.bool.isRequired,
  actions: PropTypes.shape({
    resetFiles: PropTypes.func,
    setStepIndex: PropTypes.func,
    saveAllFilesToDB: PropTypes.func.isRequired
  }).isRequired
};
UploadStepper.defaultProps = {
  selectedOrganization: null
};
export default UploadStepper;
